import React from 'react'
import TasksCounter from './shared/TasksCounter'

class BenefitThumb extends React.Component {
  taskCount() {
    return this.props.benefit.timeline_items.length;
  }

  handleClick(e){
    e.preventDefault();
    const _this = this;
    return $.getJSON(`/leave_plan_benefits/${this.props.benefit.id}/fetch_details`, data => {
      gon.company_variables  = {...gon.company_variables, ...data.statutory_substitutions_options}
      return _this.props.handleOnClick(_this.props.benefit, data.description);
    });
  }

  _allTasksAdded() {
    const { timeline_items } = this.props.benefit;
    if (timeline_items) {
      const data = $.map(timeline_items, item => item.added_to_leave_plan);
      if (($.inArray(false, data) === -1) && this.props.benefit.added_to_leave_plan) {
        return '';
      } else {
        return 'all-not-added';
      }
    }
  }

  _filtered() {
    return !this.props.benefit.theme_id || ($.inArray(this.props.benefit.theme_id, this.props.themes) !== -1);
  }

  render() {
    const pendingClass = this.props.benefit.pending ?
                      'pending'
                    :
                      '';
    const pendingTitle = this.props.benefit.pending ?
                      'Pending Review:'
                    :
                      '';
    const divStyle =
      {backgroundImage: `url(${this.props.benefit.image_url})`};
    return (
      <div>
        { this._filtered() &&
          <div className='col-md-4'>
            <a href='' onClick={this.handleClick.bind(this)}>
              <div className='benefit-item tasks-counter'>
                <div style={divStyle} className='benefit-image-div'>
                </div>
                <div className={`item-title ${this._allTasksAdded()}`}>
                  <h3>
                    <span className={`item-name ${this._allTasksAdded()}${pendingClass}`}>
                      {`${pendingTitle} ${this.props.benefit.title}`}
                      {this.taskCount() > 0 && <TasksCounter tasksCount={this.taskCount()}/>}
                    </span>
                  </h3>
                </div>
              </div>
            </a>
            <div className='benefit-item-desc'>
              <p dangerouslySetInnerHTML={{__html: this.props.benefit.summary.substring(0, 125) + '...'}} />
              <div className='read-more'>
                <a href='' onClick={this.handleClick.bind(this)}>
                  Read more
                </a>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }

}

export default BenefitThumb
